import { mapValues } from 'lodash';
import { SlidePinLayoutTemplate, SlideTeacherPin } from '../../models';
import { PinCreationParams } from './pin-helper-types';

export const newSlidePin = (layout: SlidePinLayoutTemplate): PinCreationParams<SlideTeacherPin> => {
  return {
    type: 'SLIDE',
    settings: {
      layout: layout.key,
      backgroundColor: layout.backgroundColor,
      layoutParts: mapValues(layout.layoutParts, (comp) => comp?.id),
      ...(layout.backgroundImage ? { backgroundImage: layout.backgroundImage } : {}),
      ...(layout.backgroundTransparency ? { backgroundTransparency: layout.backgroundTransparency } : {}),
    },
    pinComponents: [...Object.values(layout.layoutParts), ...layout.pinComponents],
    teacherSettings: {},
  };
};
